const ERROR_KEY_MAP = [
  { pattern: /access denied/i, key: 'component.label.access_denied', fallback: 'Access Denied' },
  { pattern: /unauthorized/i, key: 'component.label.access_denied', fallback: 'Access Denied' },
  { pattern: /forbidden/i, key: 'component.label.access_denied', fallback: 'Access Denied' },
  { pattern: /failed to create booking token/i, key: 'error.booking_token_failed', fallback: 'Failed to create booking token.' },
  { pattern: /failed to (retrieve|get) (opportunity|booking opportunity)/i, key: 'error.booking_opportunity_failed', fallback: 'Failed to retrieve booking opportunity.' },
  { pattern: /failed to create (related purchaser contact|purchaser contact)/i, key: 'error.create_contact_failed', fallback: 'Failed to create purchaser contact.' },
  { pattern: /failed to create (related purchaser record|purchaser record)/i, key: 'error.create_customer_failed', fallback: 'Failed to create purchaser record.' },
  { pattern: /something went wrong/i, key: 'error.generic', fallback: 'Something went wrong. Please try again later.' },
];

export const parseApiError = (error, t) => {
  const raw = error?.graphQLErrors?.[0]?.message || error?.message || '';

  const jsonMatch = raw.match(/\{[\s\S]*\}/);
  let msg = raw;
  if (jsonMatch) {
    try {
      msg = JSON.parse(jsonMatch[0])?.error_message || raw;
    } catch {
      /* noop */
    }
  }

  if (!msg) {
    return t('error.generic', 'Something went wrong. Please try again later.');
  }

  const matched = ERROR_KEY_MAP.find(({ pattern }) => pattern.test(msg));
  if (matched) {
    return t(matched.key, matched.fallback);
  }

  return t('error.generic', 'Something went wrong. Please try again later.');
};

export default parseApiError;
